import { useEffect, useState } from 'react';
import { FaHockeyPuck } from 'react-icons/fa';
import { GiWhistle } from 'react-icons/gi';
import APIMatches from '../../api/matches';
import ItemImage from '../../components/ItemImage';

export const Details = ({ store }) => {
    const [eventsByPeriod, setEventsByPeriod] = useState(null);
    const [game, setGame] = useState(null);

    useEffect(() => {
        const getDetails = async () => {
            try {
                const res = await APIMatches.getMatchDetails(store.selectedMatch.id);
                const allEvents = res?.data?.events || [];

                const grouped =
                    allEvents.length > 0
                        ? [1, 2, 3].map((period) => ({
                              period,
                              events: allEvents.filter((e) => e.period === period),
                          }))
                        : [];

                setEventsByPeriod(grouped);
                setGame(res?.data?.game);
            } catch (e) {
                console.log(e);
            }
        };

        if (store?.selectedMatch) getDetails();
    }, [store]);

    if (eventsByPeriod === null) return null;

    return eventsByPeriod?.length > 0 ? (
        <div className="details-wrapper">
            <div className="team-logos">
                <ItemImage imgSrc={game?.home_team.image_url} listView={true} />
                VS.
                <ItemImage imgSrc={game?.away_team.image_url} listView={true} />
            </div>
            {eventsByPeriod.map(({ period, events }) => (
                <div key={period} className="game-part">
                    <h5 className="game-part-title">{period}. DRITTEL</h5>
                    <div className="game-events">
                        {events.map((e, i) => {
                            if (e.type === 'goal') {
                                return (
                                    <div
                                        key={i}
                                        className={`game-event ${
                                            e.is_home ? 'home_team' : 'away_team'
                                        }`}
                                    >
                                        <div
                                            className={`time ${
                                                e.is_home ? 'home_team' : 'away_team'
                                            }`}
                                        >
                                            {e.time && <p>{e.time}</p>}
                                            <FaHockeyPuck size={24} />
                                        </div>

                                        {e.scorer && <p className="player">{e.scorer}</p>}
                                        {e.assist_1 && (
                                            <p className="additional-details">{e.assist_1}</p>
                                        )}
                                        {e.assist_2 && (
                                            <p className="additional-details">{e.assist_2}</p>
                                        )}
                                    </div>
                                );
                            }

                            if (e.type === 'foul') {
                                return (
                                    <div
                                        key={i}
                                        className={`game-event ${
                                            e.is_home ? 'home_team' : 'away_team'
                                        }`}
                                    >
                                        <div
                                            className={`time ${
                                                e.is_home ? 'home_team' : 'away_team'
                                            }`}
                                        >
                                            {e.time && <p>{e.time}</p>}
                                            <GiWhistle size={30} />
                                        </div>

                                        {e.player && (
                                            <p className="player">
                                                {e.player}{' '}
                                                {e.player_jersey_number &&
                                                    `(${e.player_jersey_number})`}
                                            </p>
                                        )}
                                        <p className="additional-details">{e.foul_name}</p>
                                    </div>
                                );
                            }

                            return null;
                        })}
                    </div>
                </div>
            ))}
        </div>
    ) : (
        <p>No details available</p>
    );
};
